module.exports = {"mapbox_accessToken":"pk.eyJ1IjoiZmFkZXYiLCJhIjoiY2o2eXNodXpnMjJnbzJybXRmMWtwajVrdyJ9.djCM8zBqCtA-SC_EChxtzQ"}


// WEBPACK FOOTER //
// ./src/credentials/config.json